import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { backend } from "../../api";
import {
  ADD_BOOK_FAIL,
  ADD_BOOK_REQUEST,
  ADD_BOOK_SUCCESS,
  BOOK_ORDER_FAIL,
  BOOK_ORDER_REQUEST,
  BOOK_ORDER_SUCCESS,
  FETCH_BOOK_FAIL,
  FETCH_BOOK_REQUEST,
  FETCH_BOOK_SUCCESS,
  FETCH_ORDERS_FAIL,
  FETCH_ORDERS_REQUEST,
  FETCH_ORDERS_SUCCESS,
  FETCH_PREORDER_BOOKS_FAIL,
  FETCH_PREORDER_BOOKS_REQUEST,
  FETCH_PREORDER_BOOKS_SUCCESS,
  RESET_BOOK,
  UPDATE_BOOK_FAIL,
  UPDATE_BOOK_SUCCESS,
} from "../constants";

export const fetchPreOrderBooks = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_PREORDER_BOOKS_REQUEST });
    const { data } = await backend.get(
      "/book?isPublished=true&pre_order=true&isActive=true&price"
    );
    dispatch({ type: FETCH_PREORDER_BOOKS_SUCCESS, payload: data.data });
  } catch (error) {
    toast.error(error.response ? error.response.data.message : error.message);

    dispatch({
      type: FETCH_PREORDER_BOOKS_FAIL,
      payload: error.response ? error.response.data.message : error.message,
    });
  }
};

export const fetchBookDetails = (id) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_BOOK_REQUEST });
    const { data } = await backend.get(`/book?_id=${id}`);
    dispatch({ type: FETCH_BOOK_SUCCESS, payload: data.data[0] });
  } catch (error) {
    toast.error(error.response ? error.response.data.message : error.message);

    dispatch({
      type: FETCH_BOOK_FAIL,
      payload: error.response ? error.response.data.message : error.message,
    });
  }
};

export const createBookOrder = (newOrder) => async (dispatch) => {
  try {
    dispatch({ type: BOOK_ORDER_REQUEST });
    const { data } = await backend.post("/bookorder", newOrder);
    Swal.fire({
      title: "Congratulations",
      icon: "success",
      confirmButtonText: "OK",
      text: "Order Placed Successfully",
    });
    dispatch({ type: BOOK_ORDER_SUCCESS, payload: data.data });
  } catch (error) {
    let message = error.response ? error.response.data.message : error.message;
    if (message === "Not Authorized, No Token")
      message = "Please Login as Customer";
    toast.error(message);
    dispatch({
      type: BOOK_ORDER_FAIL,
      payload: message,
    });
  }
};
const handleCreateUserWallet = (order) => {
  if (Boolean(order.author_amount)) {
    const authorWallet = {
      user: order.book.author,
      book_order: order._id,
      amount: order.author_amount,
      book: order.book._id,
    };
    backend
      .post(`/wallet`, authorWallet)
      .then((res) => {})
      .catch((error) => {
        toast.error(
          error.response ? error.response.data.message : error.message
        );
      });
  }
  // const adminWallet = {
  //   user: order.book.author,
  //   book_order: order._id,
  //   amount: order.owner_amount,
  //   book: order.book._id,
  // };
  // backend
  //   .post(`/wallet`, adminWallet)
  //   .then((res) => {})
  //   .catch((error) => {
  //     toast.error(error.response ? error.response.data.message : error.message);
  //   });
};

export const getUsersOrders = (id) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_ORDERS_REQUEST });
    const { data } = await backend.get(`/bookOrder?user=${id}`);
    dispatch({ type: FETCH_ORDERS_SUCCESS, payload: data.data });
  } catch (error) {
    toast.error(error.response ? error.response.data.message : error.message);

    dispatch({
      type: FETCH_ORDERS_FAIL,
      payload: error.response ? error.response.data.message : error.message,
    });
  }
};

export const editBook = (updatedBook) => async (dispatch) => {
  backend
    .put(`/book/${updatedBook.id}`, updatedBook)
    .then((res) => {
      dispatch({ type: UPDATE_BOOK_SUCCESS, payload: res.data.data[0] });
      Swal.fire({
        title: "Congratulations",
        icon: "success",
        confirmButtonText: "OK",
        text: "Book Details Updated Successfully",
      }).then((result) => {});
    })
    .catch((error) => {
      let message = error.response
        ? error.response.data.message
        : error.message;
      toast.error(message);
      dispatch({ type: UPDATE_BOOK_FAIL, payload: message });
    });
};

export const editPrice = (updatedBook, id) => async (dispatch) => {
  backend
    .put(`/book/${id}`, updatedBook)
    .then((res) => {
      dispatch({ type: UPDATE_BOOK_SUCCESS, payload: res.data.data[0] });
      Swal.fire({
        title: "Congratulations",
        icon: "success",
        confirmButtonText: "OK",
        text: "Book Details Updated Successfully",
      }).then((result) => {});
    })
    .catch((error) => {
      let message = error.response
        ? error.response.data.message
        : error.message;
      toast.error(message);
      dispatch({ type: UPDATE_BOOK_FAIL, payload: message });
    });
};

export const authorAddBook = (newBook) => async (dispatch) => {
  dispatch({ type: ADD_BOOK_REQUEST });

  backend
    .post("/book", newBook)
    .then((res) => {
      dispatch({ type: ADD_BOOK_SUCCESS });
      if (res.data.message === "Book Record Saved") {
        Swal.fire({
          title: "Congratulations",
          icon: "success",
          confirmButtonText: "OK",
          text: res.data.message,
        }).then((result) => {
          if (result.isConfirmed) {
          }
        });
      }
    })
    .catch((err) => {
      dispatch({ type: ADD_BOOK_FAIL });
      if (err.response) {
        toast.error(err.response.data.message);
      } else {
        toast.error(err.message);
      }
    });
};

export const authorAddAdverBook = (newBook) => async (dispatch) => {
  dispatch({ type: ADD_BOOK_REQUEST });
  backend
    .post("/adverbook", newBook)
    .then((res) => {
      dispatch({ type: ADD_BOOK_SUCCESS });
      Swal.fire({
        title: "Congratulations",
        icon: "success",
        confirmButtonText: "OK",
        text: res.data.message,
      }).then((result) => {
        if (result.isConfirmed) {
        }
      });
    })
    .catch((err) => {
      dispatch({ type: ADD_BOOK_FAIL });
      if (err.response) {
        toast.error(err.response.data.message);
      } else {
        toast.error(err.message);
      }
    });
};
